<template>
  <div>
    <ModulesTwoBall />
  </div>
</template>
<script>
import ModulesTwoBall from '@/components/modules/twoColorBall/index.vue'
export default {
  name: 'HelpDocument',
  components: { ModulesTwoBall }
}
</script>
